import {
  Contact,
  contactsByHabitat,
  ContactsByHabitatQueryVariables,
  createListAllQuery,
  getContact,
  GetContactQuery,
  GetContactQueryVariables,
  graphqlCall,
  listContacts,
  ListContactsQuery,
  ListContactsQueryVariables,
} from '@akin-home/amplify';

export const listContactsQuery = (params?: ListContactsQueryVariables) =>
  graphqlCall<ListContactsQuery>(listContacts, params);

export const listAllContactsQuery = createListAllQuery<
  Contact,
  ListContactsQueryVariables
>(listContacts, 'listContacts');

export const listAllContactsForHabitatQuery = createListAllQuery<
  Contact,
  ContactsByHabitatQueryVariables
>(contactsByHabitat, 'contactsByHabitat');

/** Query to get a single contact */
export const getContactQuery = (params: GetContactQueryVariables) =>
  graphqlCall<GetContactQuery>(getContact, params);
